/* eslint-disable */
export default {
  Home: 'Etusivu',
  Mobile: 'Mobiili',
  Work: 'Työ',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
